import comp from "./AttachmentLoaderMenu";
export default comp;
